// Part of the Chili3d Project, under the AGPL-3.0 License.
// See LICENSE file in the project root for full license information.

import { Locale } from "./i18n";

export default {
    display: "日本語",
    code: "ja",
    translation: {
        "arc.angle": "角度",
        "arc.start": "開始点",
        "axis.x": "X軸",
        "axis.y": "Y軸",
        "axis.z": "Z軸",
        "body.arc": "円弧",
        "body.bolean": "ブーリアン",
        "body.box": "ボックス",
        "body.pyramid": "ピラミッド",
        "body.cylinder": "円柱",
        "body.cone": "円錐",
        "body.group": "グループ",
        "body.sphere": "球体",
        "body.ellipse": "楕円",
        "body.circle": "円",
        "body.face": "面",
        "body.fuse": "結合",
        "body.imported": "インポート済み",
        "body.line": "線",
        "body.polygon": "ポリライン",
        "body.prism": "押し出し",
        "body.rect": "長方形",
        "body.revol": "回転",
        "body.sweep": "スイープ",
        "body.wire": "ワイヤー",
        "box.dx": "長さ",
        "box.dy": "幅",
        "box.dz": "高さ",
        "body.editableShape": "編集可能な形状",
        "body.meshNode": "メッシュノード",
        "body.multiShape": "複数形状",
        "circle.center": "中心",
        "circle.radius": "半径",
        "ellipsoid.radiusX": "X半径",
        "ellipsoid.radiusY": "Y半径",
        "ellipsoid.radiusZ": "Z半径",
        "ellipse.majorRadius": "長径",
        "ellipse.minorRadius": "短径",
        "command.act.alignCamera": "カメラ整列",
        "command.boolean.common": "交差",
        "command.boolean.cut": "切断",
        "command.boolean.join": "結合",
        "command.convert.fuse": "結合",
        "command.convert.revol": "回転",
        "command.convert.sweep": "スイープ",
        "command.convert.toFace": "面に変換",
        "command.convert.toShell": "シェルに変換",
        "command.convert.toSolid": "ソリッドに変換",
        "command.convert.toWire": "ワイヤーに変換",
        "command.convert.curveProjection": "投影",
        "command.create.arc": "円弧",
        "command.create.bezier": "ベジェ",
        "command.create.box": "ボックス",
        "command.create.circle": "円",
        "command.create.cone": "円錐",
        "command.create.copyShape": "形状コピー",
        "command.create.cylinder": "円柱",
        "command.create.ellipse": "楕円",
        "command.create.ellipsoid": "楕円体",
        "command.create.extrude": "押し出し",
        "command.create.folder": "フォルダ",
        "command.create.group": "グループ",
        "command.create.line": "線",
        "command.create.offset": "オフセット",
        "command.create.polygon": "ポリライン",
        "command.create.pyramid": "ピラミッド",
        "command.create.rect": "長方形",
        "command.create.section": "断面",
        "command.create.sphere": "球体",
        "command.create.thickSolid": "厚みソリッド",
        "command.doc.new": "新規ドキュメント",
        "command.doc.open": "ドキュメントを開く",
        "command.doc.save": "ドキュメントを保存",
        "command.doc.saveToFile": "ファイルに保存",
        "command.edit.redo": "やり直し",
        "command.edit.undo": "元に戻す",
        "command.file.export": "エクスポート",
        "command.file.import": "インポート",
        "command.file.stepUnfold": "展開図",
        "command.measure.angle": "角度",
        "command.measure.length": "長さ",
        "command.measure.select": "選択",
        "command.modify.array": "配列",
        "command.modify.break": "分割",
        "command.modify.brushAdd": "ブラシ追加",
        "command.modify.brushRemove": "ブラシ削除",
        "command.modify.brushClear": "ブラシクリア",
        "command.modify.chamfer": "面取り",
        "command.modify.deleteNode": "ノード削除",
        "command.modify.explode": "分解",
        "command.modify.fillet": "フィレット",
        "command.modify.mirror": "ミラー",
        "command.modify.move": "移動",
        "command.modify.removeFeature": "フィーチャー削除",
        "command.modify.removeShapes": "形状削除",
        "command.modify.rotate": "回転",
        "command.modify.split": "分割",
        "command.modify.trim": "トリム",
        "command.special.last": "__最後のコマンド__",
        "command.test.performace": "パフォーマンステスト",
        "command.settings.units": "単位設定",
        "command.wechat.group": "WeChat",
        "command.workingPlane.alignToPlane": "整列",
        "command.workingPlane.fromSection": "断面",
        "command.workingPlane.set": "設定",
        "command.workingPlane.toggleDynamic": "切り替え",
        "common.angle": "角度",
        "common.area": "面積",
        "common.back": "戻る",
        "common.language": "言語",
        "common.3DNavigation": "3Dナビゲーション",
        "common.cancel": "キャンセル",
        "common.clone": "複製",
        "common.color": "色",
        "common.confirm": "確認",
        "common.general": "一般",
        "common.length": "長さ",
        "common.dir": "方向",
        "common.material": "マテリアル",
        "common.matrix": "行列",
        "common.name": "名前",
        "common.normal": "法線",
        "common.opacity": "不透明度",
        "common.thickness": "厚さ",
        "common.type": "タイプ",
        "common.volume": "体積",
        "dialog.title.selectWorkingPlane": "作業平面を選択",
        "entity.editable": "編集可能エンティティ",
        "entity.parameter": "パラメータエンティティ",
        "error.default:{0}": "エラー: {0}",
        "error.input.cannotInputANumber": "参照点と重複しています。1つの数値を入力できません",
        "error.input.invalidNumber": "有効な数値を入力してください。カンマで区切ってください",
        "error.input.threeNumberCanBeInput": "参照点が空です。3つの数値のみ入力できます",
        "error.input.unsupportedInputs": "最大入力数を超えています",
        "error.import.unsupportedFileType:{0}": "サポートされていないファイルタイプ: {0}",
        "error.export.noNodeCanBeExported": "エクスポート可能なノードがありません",
        "file.format": "フォーマット",
        "home.recent": "最近使用したファイル",
        "home.welcome": "Diorama-CADへようこそ",
        "items.header": "アイテム",
        "items.tool.delete": "削除",
        "items.tool.expandAll": "すべて展開",
        "items.tool.newFolder": "新規フォルダ",
        "items.tool.unexpandAll": "すべて折りたたむ",
        "line.end": "終点",
        "line.start": "始点",
        "line.type.line": "線",
        "line.type.xline": "構築線",
        "material.texture.image": "画像",
        "material.texture.rotation": "回転",
        "material.texture.wrapS": "ラップS",
        "material.texture.wrapT": "ラップT",
        "material.texture.repeat": "繰り返し",
        "material.texture.offset": "オフセット",
        "material.map": "マップ",
        "material.specular": "スペキュラー",
        "material.shininess": "光沢",
        "material.emissive": "発光",
        "material.specularMap": "スペキュラーマップ",
        "material.normalMap": "法線マップ",
        "material.bumpMap": "バンプマップ",
        "material.roughnessMap": "粗さマップ",
        "material.emissiveMap": "発光マップ",
        "material.metalness": "金属度",
        "material.metalnessMap": "金属度マップ",
        "material.roughness": "粗さ",
        "model.visible": "表示",
        "option.command.repeat": "繰り返し",
        "option.command.isFace": "面",
        "option.command.isRoundCorner": "角丸",
        "option.command.thickness": "厚さ",
        "option.command.isConnected": "接続",
        "option.command.isConvertInstance": "インスタンス変換",
        "option.command.insertPoint": "挿入点",
        "polygon.points": "ポイント",
        "prompt.default{0}{1}": "{0}でビューを移動、{1}でビューを回転、マウスホイールでズーム",
        "prompt.deleteDocument{0}": "{0}を削除しますか？",
        "prompt.pickCircleCenter": "中心を選択、ESCキーでキャンセル",
        "prompt.pickFistPoint": "最初の点を選択、ESCキーでキャンセル",
        "prompt.pickNextPoint": "次の点を選択、ESCキーでキャンセル",
        "prompt.pickRadius": "半径を入力、ESCキーでキャンセル",
        "prompt.polygon.close": "閉じる",
        "prompt.saveDocument{0}": "{0}への変更を保存しますか？",
        "prompt.select.edges": "エッジを選択してください",
        "prompt.select.faces": "面を選択してください",
        "prompt.select.models": "展開する3D形状を選択してください",
        "prompt.select.noModelSelected": "モデルが選択されていません",
        "prompt.select.section": "断面を選択してください",
        "prompt.select.shape": "形状を選択してください",
        "prompt.select.solids": "ソリッドを選択してください",
        "prompt.select.path": "パスを選択してください",
        "prompt.select.vertexes": "頂点を選択してください",
        "prompt.select.wires": "ワイヤーを選択してください",
        "toast.snap.notFoundValidPoint": "有効な点が見つかりません",
        "properties.group.transform": "変換",
        "properties.header": "プロパティ",
        "properties.multivalue": "複数値",
        "rect.dx": "長さ",
        "rect.dy": "幅",
        "ribbon.group.2d": "2D",
        "ribbon.group.3d": "3D",
        "ribbon.group.act": "アクション",
        "ribbon.group.boolean": "ブーリアン",
        "ribbon.group.brush": "ブラシ",
        "ribbon.group.converter": "コンバーター",
        "ribbon.group.draw": "描画",
        "ribbon.group.edit": "編集",
        "ribbon.group.importExport": "インポート/エクスポート",
        "ribbon.group.measure": "測定",
        "ribbon.group.modify": "修正",
        "ribbon.group.other": "その他",
        "ribbon.group.selection": "選択",
        "ribbon.group.tools": "ツール",
        "ribbon.group.transform": "変形",
        "ribbon.group.workingPlane": "作業平面",
        "ribbon.tab.converter": "コンバーター",
        "ribbon.tab.draw": "描画",
        "ribbon.tab.file": "ファイル",
        "ribbon.tab.modify": "修正",
        "ribbon.tab.tools": "ツール",
        "ribbon.tab.startup": "スタートアップ",
        "snap.center": "中心",
        "snap.end": "端点",
        "snap.intersection": "交点",
        "snap.mid": "中点",
        "snap.perpendicular": "垂直",
        "snap.nearest": "近接点",
        "statusBar.snap": "スナップ",
        "statusBar.tracking": "トラッキング",
        "unit.millimeter": "ミリメートル",
        "unit.centimeter": "センチメートル",
        "unit.meter": "メートル",
        "unit.inch": "インチ",
        "unit.foot": "フィート",
        "unit.degree": "度",
        "unit.radian": "ラジアン",
        "unit.lengthUnit": "長さ単位",
        "unit.angleUnit": "角度単位",
        "unit.lengthPrecision": "長さ精度",
        "unit.anglePrecision": "角度精度",
        "unit.settings": "単位設定",
        "toast.command.{0}excuting": "コマンド {0} を実行中",
        "toast.converter.error": "コンバーターエラー",
        "toast.converter.invalidColor": "無効な色です",
        "toast.delete{0}Objects": "{0}個のオブジェクトを削除しました",
        "toast.document.noActivated": "アクティブなドキュメントがありません",
        "toast.document.saved": "ドキュメントを保存しました",
        "toast.downloading": "ダウンロード中",
        "toast.excuting{0}": "{0}を実行中",
        "toast.fail": "失敗",
        "toast.read.error": "読み込みエラー",
        "toast.select.noSelected": "選択されていません",
        "toast.success": "成功",
        "toast.stepUnfold.success": "展開図を生成しました",
        "toast.stepUnfold.error": "展開図の生成に失敗しました",
        "stepUnfold.scale": "縮尺",
        "stepUnfold.scale.label": "縮尺: 1/{0}",
        "stepUnfold.modelSize": "想定模型サイズ: 最大 {0}mm",
        "stepUnfold.experimental": "🧪 実験的機能",
        "stepUnfold.experimentalWarning": "この機能は実験段階です。正確性を保証するものではありません。",
        "stepUnfold.layoutMode": "レイアウトモード",
        "stepUnfold.layoutMode.canvas": "キャンバス",
        "stepUnfold.layoutMode.paged": "ページ分割",
        "stepUnfold.pageFormat": "ページフォーマット",
        "stepUnfold.pageFormat.A4": "A4",
        "stepUnfold.pageFormat.A3": "A3",
        "stepUnfold.pageFormat.Letter": "レター",
        "stepUnfold.pageOrientation": "向き",
        "stepUnfold.pageOrientation.portrait": "縦",
        "stepUnfold.pageOrientation.landscape": "横",
        "transform.rotation": "回転",
        "transform.scale": "スケール",
        "transform.translation": "移動",
        "vertex.point": "点",
    },
} satisfies Locale;
